import { render, staticRenderFns } from "./CatalogCategoryTree.vue?vue&type=template&id=06a2232a&"
import script from "./CatalogCategoryTree.vue?vue&type=script&lang=ts&"
export * from "./CatalogCategoryTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports